import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

aframe.registerComponent("city", {
  reset() {
    this.el.setAttribute("gltf-blender-part", "part", "city");
    this.isDead = false;
  },
  destroyed() {
    if (this.isDead) {
      return;
    }
    this.el.setAttribute("gltf-blender-part", "part", "city-destroyed");
    this.isDead = true;
    this.el.emit("citydestroyed");
  },
  collisionstart: bindEvent(function(evt) {
    this.destroyed();
  }),
  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = evt.detail;
    if (newState === "MainMenu" || newState === "NewGame") {
      this.reset();
    } else if (newState === "GameOver") {
      this.destroyed();
    }
  })
});
